import qs from 'query-string';

const key = 'AIzaSyA6BPfK0I0v-f5rltHPAQdpgKkCuftke3Q';
const base = 'https://maps.googleapis.com/maps/api/staticmap';
const format = 'png';
// const style = [
//   'feature:all|element:labels.icon|hue:0x7393A8',
//   'feature:poi|element:labels.text|visibility:off',
//   'feature:poi.business|visibility:off',
//   'feature:poi.park|element:geometry|color:0xBDE6AF',
//   'feature:road.local|element:labels|visibility:off',
//   'feature:transit|visibility:off',
//   'feature:landscape|color:0xDDE3E3',
//   'feature:landscape.natural.terrain|color:0xBDE6AF',
//   'feature:road|element:geometry.fill|color:0xffffff',
//   'feature:road|element:geometry.stroke|color:0xffffff',
//   'feature:road.highway|element:geometry.fill|color:0xCFDBDD',
//   'feature:road.highway|element:geometry.stroke|color:0xC3CDD0'
// ];

const style = [
  'element:geometry|color:0xf5f5f5',
  'element:labels.icon|visibility:off',
  'element:labels.text.fill|color:0x616161',
  'element:labels.text.stroke|color:0xf5f5f5',
  'feature:administrative.land_parcel|visibility:off',
  'feature:administrative.locality|element:labels.text.stroke|color:0xe2e2e2',
  'feature:administrative.neighborhood|visibility:off',
  'feature:landscape|element:geometry.fill|color:0xd6d6d6',
  'feature:poi|element:geometry|color:0xeeeeee',
  'feature:poi|element:geometry.fill|color:0xcbcbcb',
  'feature:poi|element:labels.text|visibility:off',
  'feature:poi|element:labels.text.fill|color:0x757575',
  'feature:poi.business|visibility:off',
  'feature:poi.park|element:geometry|color:0xe5e5e5',
  'feature:poi.park|element:labels.text|visibility:off',
  'feature:poi.park|element:labels.text.fill|color:0x9e9e9e',
  'feature:road|element:geometry|color:0xffffff',
  'feature:road|element:geometry.fill|color:0xe6e6e6',
  'feature:road|element:labels|visibility:off',
  'feature:road.arterial|element:labels.text.fill|color:0x757575',
  'feature:road.highway|element:geometry|color:0xdadada',
  'feature:road.highway|element:geometry.fill|color:0xcbcbcb',
  'feature:road.highway|element:labels.text.fill|color:0x616161',
  'feature:road.local|element:labels.text.fill|color:0x9e9e9e',
  'feature:transit|visibility:off',
  'feature:transit.line|element:geometry|color:0xe5e5e5',
  'feature:transit.station|element:geometry|color:0xeeeeee',
  'feature:water|element:geometry|color:0xc9c9c9',
  'feature:water|element:geometry.fill|color:0xc0c0c0',
  'feature:water|element:labels.text|visibility:off',
  'feature:water|element:labels.text.fill|color:0x9e9e9e'
];
export function getMapCenteredOnSuburb(suburb, postcode) {
  const query = qs.stringify({
    size: '640x640',
    zoom: 14,
    scale: 2,
    center: `${suburb || 'Australia'},${`${postcode}`.padStart(4, '0')}`,
    format,
    key,
    style
  });
  return `${base}?${query}`;
}

export function getPostcodeSuburbFromGoogleAddress(place) {
  let suburb = '';
  let postcode = '';
  if (place !== undefined && place.address_components !== undefined) {
    place.address_components.forEach(address => {
      const addressType = address.types[0];
      if (addressType === 'locality') {
        suburb = address['short_name'];
      } else if (addressType === 'postal_code') {
        postcode = address['short_name'];
      }
    });
  }
  if (suburb.length === 0) {
    return '';
  }
  return `${postcode} - ${suburb}`;
}
